import { Enumify } from "enumify-ts";
class MarketplaceBillingType extends Enumify() {
    description;
    static ON_ACCOUNT = new MarketplaceBillingType("On Account (Credit Approved)");
    static PAY_AS_YOU_GO = new MarketplaceBillingType("Pay As You Go (Credit card)");
    static PAYABLES_ONLY = new MarketplaceBillingType("Payables Only (Quarries/Tip Sites)");
    static ON_HOLD = new MarketplaceBillingType("On Hold (Blocked)");
    static _ = MarketplaceBillingType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return MarketplaceBillingType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default MarketplaceBillingType;
